module.exports = __webpack_public_path__ + "static/media/materialAwesome.33bf8cd5.eot";